import React from 'react';

import { useScrollRegion } from './ScrollRegionContext';

export type ScrollRegionFooterProps = {
  children?: React.ReactNode;
  name?: string;
};

/**
 * The box docked at the region's bottom edge, registered with the region so it holds that much
 * clear when something is scrolled into view near the end - without which a target lands underneath
 * whatever is docked there.
 *
 * It draws nothing of its own: docking it, and anything it looks like, are the caller's.
 */
export const ScrollRegionFooter = ({
  children,
  name,
}: ScrollRegionFooterProps) => {
  const { footerRef } = useScrollRegion();

  return (
    <div data-test={name} ref={footerRef}>
      {children}
    </div>
  );
};
